<form [formGroup]="resetPasswordForm">
    <input type="text" formControlName="password">
    <input type="text" formControlName="confirm_password">
    <button type="submit" [disabled="!resetPasswordForm.valid" ]> Submit</button>

</form>